import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Chapter as C } from "@mikros/library";
import {
  Checkbox,
  CheckboxChangeEvent,
  TextArea,
  TextAreaChangeEvent,
} from "@progress/kendo-react-inputs";
import React, { useEffect, useRef, useState } from "react";
import { SortableItemUIProps } from "@progress/kendo-react-sortable";

export interface ChapterProps extends SortableItemUIProps {
  handleChecked: (chapterId: string) => void;
  reqListChapters: string[];
  enableDrag: boolean;
  handleEnableDrag: (e: boolean) => void;
  handleChapterUpd: (chpt: C) => void;
}

export function ChapterData(props: ChapterProps) {
  console.log("inside the file chapter data");

  const { style, attributes, dataItem, forwardRef } = props;
  const [show, setShow] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [chapterData, setChapterData] = useState<C>(dataItem);
  console.log(
    "request list chapter data item",
    props.reqListChapters.includes(dataItem.chapterId)
  );
  const [chapterName, setChapterName] = useState<string>(
    props.dataItem.chapterName
  );

  useEffect(() => {
    console.log("inside use effect of check");
    setChapterData(dataItem);
    if (props.reqListChapters.includes(dataItem.chapterId)) {
      console.log("dsn1,hello i am checked");
      setChecked(true);
    } else {
      console.log("dsn1,sorry not checked");
      setChecked(false);
    }
  }, [dataItem]);

  useEffect(() => {
    props.handleEnableDrag(props.enableDrag);
  }, [props.enableDrag]);

  const sampleRef = useRef();

  const handleChangeData = (e: TextAreaChangeEvent) => {
    let chpt = { ...chapterData };
    chpt.description = e.value;
    props.handleChapterUpd(chpt);
  };

  const handleChangeChapterName = () => {
    let chpt = { ...chapterData };
    chpt.chapterName = chapterName;
    props.handleChapterUpd(chpt);
  };
  return (
    <div
      ref={props.enableDrag ? forwardRef : sampleRef}
      {...attributes}
      style={
        props.enableDrag
          ? {
              ...style,
            }
          : {}
      }
      className="mx-2"
    >
      <div
        className={`w-full mb-4 
           ${checked ? "bg-mk-primary-50" : "bg-mk-primary-20"} 
        ${show ? "rounded-3xl" : "rounded-full hover:shadow-xl"}
        space-y-3 px-5 p-3 flex flex-col justify-center items-start`}
      >
        <div
          className="w-full flex justify-between items-center"
          onClick={() => props.handleEnableDrag(false)}
        >
          <div className="flex place-items-center space-x-2 justify-center items-center">
            <div>
              <Checkbox
                value={checked}
                onChange={(e: CheckboxChangeEvent) => {
                  setShow(e.value);
                  console.log(
                    "chapter data chapter name",
                    chapterData.chapterName
                  );
                  setChecked(e.value);
                  console.log("The chapter Id is", chapterData.chapterId);
                  props.handleChecked(chapterData.chapterId);
                }}
                disabled={chapterData.chapterName === ""}
              ></Checkbox>
            </div>
            <FontAwesomeIcon
              icon={["far", "fa-arrows-up-down-left-right" as IconName]}
              className="h-4 w-4 hover:cursor-grab mx-3 text-mk-primary-bright flex-shrink-0"
              onMouseEnter={(e) => {
                handleChangeChapterName();
                e.stopPropagation();
                props.handleEnableDrag(true);
              }}
            />

            <input
              id={"chapterDiv"}
              className={`editable-div p-1 rounded-lg md:text-sm sm:text-[12px] px-2 inline-block
                ${
                  checked
                    ? "bg-mk-primary font-bold"
                    : "bg-mk-primary-50 font-bold"
                }`}
              style={{ width: `${chapterName.length + 2}ch` }}
              onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                setChapterName(event.target.value);
              }}
              onBlur={() => {
                handleChangeChapterName();
              }}
              onMouseEnter={(e) => {
                props.handleEnableDrag(false);
              }}
              value={chapterName}
            />
          </div>
          {checked ? (
            <div onClick={() => setShow(!show)}>
              <FontAwesomeIcon
                icon={["fas", "fa-play" as IconName]}
                className={`h-4 w-4 mx-3 hover:cursor-pointer
                  text-mk-primary-bright
                   ${!show ? "" : "rotate-90"}`}
                onClick={() => props.handleEnableDrag(false)}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className={show ? "rounded-full w-[50%]" : "hidden"}>
          <TextArea cols={90} rounded={"large"} onChange={handleChangeData}>
            {chapterData.description}
          </TextArea>
        </div>
      </div>
    </div>
  );
}
